import RotateDevice from "./RotateDevice";

export default RotateDevice;